import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

const NotFoundPage: React.FC = () => {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate('/gallery');
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '100vh',
				width: '100vw',
				background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
				color: '#111827',
				p: 4,
				overflow: 'hidden',
				position: 'relative'
			}}
		>
			{/* Decorative background elements */}
			<Box
				sx={{
					position: 'absolute',
					top: '-10%',
					left: '-5%',
					width: '40vw',
					height: '40vw',
					borderRadius: '50%',
					background: 'radial-gradient(circle, rgba(139,92,246,0.15) 0%, rgba(255,255,255,0) 70%)',
					filter: 'blur(60px)',
					zIndex: 0,
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					bottom: '-10%',
					right: '-5%',
					width: '50vw',
					height: '50vw',
					borderRadius: '50%',
					background: 'radial-gradient(circle, rgba(139,92,246,0.1) 0%, rgba(255,255,255,0) 70%)',
					filter: 'blur(80px)',
					zIndex: 0,
				}}
			/>

			<Paper
				elevation={24}
				sx={{
					p: { xs: 4, md: 6 },
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					maxWidth: 650,
					width: '100%',
					textAlign: 'center',
					borderRadius: 4,
					background: '#ffffff',
					zIndex: 1,
					boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
				}}
			>
				<Typography 
					variant="h1" 
					sx={{ 
						fontWeight: 900, 
						fontSize: { xs: '6rem', md: '8rem' },
						background: 'linear-gradient(to right, #8B5CF6, #3B82F6)',
						WebkitBackgroundClip: 'text',
						WebkitTextFillColor: 'transparent',
						lineHeight: 1,
						mb: 2
					}}
				>
					404
				</Typography>
				
				<Typography variant="h4" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.5px', color: '#111827' }}>
					Page Not Found
				</Typography>
				
				<Typography variant="h6" sx={{ mb: 4, color: '#4B5563', fontWeight: 400, lineHeight: 1.6 }}>
					The page you are looking for doesn't exist, has been moved, or is temporarily unavailable.
				</Typography>
				
				<Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', sm: 'row' }, width: '100%', justifyContent: 'center' }}>
					<Button 
						variant="contained" 
						size="large"
						startIcon={<HomeIcon />}
						onClick={handleGoHome}
						sx={{ 
							background: '#8B5CF6',
							color: '#ffffff',
							fontWeight: 600,
							px: 4,
							py: 1.5,
							borderRadius: 3,
							textTransform: 'none',
							fontSize: '1.1rem',
							boxShadow: '0 4px 14px 0 rgba(139, 92, 246, 0.39)',
							'&:hover': {
								background: '#7C3AED',
								boxShadow: '0 6px 20px rgba(139, 92, 246, 0.4)',
							}
						}}
					>
						Back to Gallery
					</Button>
				</Box>
			</Paper>
		</Box>
	);
};

export default NotFoundPage;
